import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.al = bracketIndenting()
